














import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

@Component({
  name: 'respondeco-toolbar-item',
})
export default class RespondecoToolbarItem extends Vue {
  @Prop({
    type: String,
  })
  public readonly icon?: string

  @Prop({
    type: [Object, String],
  })
  public readonly to?: any
}
